
import { ClassFlag } from "../../../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../../../library-js/dom-tools/ElementType";
import { deepClone } from "../../../../../library-js/tools/TypeUtilities";
import { DomElement } from "../../../../../library/ts/html/dom/DomElement";
import { ReminderEntry } from "../app/data/ReminderEntry";
import { ReminderApp } from "../app/ReminderApp";
import { ReminderMailView } from "./reminder-mail-view";
import { ReminderMain } from "./reminder-main";


export class ReminderUI extends DomElement<HTMLElement>
{
  static type = new ElementType( "reminder-ui" );

  _reminderMain:ReminderMain;
  _reminderMailView:ReminderMailView;


  get windows():DomElement<any>[]
  {
    return [ this._reminderMain, this._reminderMailView ];
  }

  _activeWindow:DomElement<any>; 
  protected _reminderApp:ReminderApp;
  get app(){ return this._reminderApp; }

  setApp( reminderApp:ReminderApp )
  {
    this._reminderApp = reminderApp;

    this._reminderMain = this.get( ReminderMain );
    this._reminderMailView = this.get( ReminderMailView );

    this._reminderMailView.initialize( this );

    this._activeWindow = this._reminderMain;


    this._reminderMain.mailButton.onClick( 
      ( ev ) => 
      { 
        try
        { 
          reminderApp.createNewMailEntry();

        }
        catch( e )
        {
          alert( e.message );
        }
        
        this._reminderMailView.setEntry( reminderApp._editMailEntry );
        this.setActiveWindow( this._reminderMailView );        
        this._reminderMailView.setEntry( reminderApp._editMailEntry );
      } 
    );

    this._reminderMailView.backButton.onClick( 
      ( ev ) => 
      { 
        this._reminderMain.loadEntries( this.app.entries, this );
        this.setActiveWindow( this._reminderMain );
        this._reminderApp._editMailEntry = null;
      } 
    );

    this._reminderMailView.deleteButton.onClick( 
      async ( ev ) => 
      { 
        let entry = deepClone( reminderApp._editMailEntry );
        let index = reminderApp.data.mailEntries.findIndex( me => me.id === entry.id );

        if ( index !== -1 )
        {
          reminderApp.data.mailEntries.splice( index, 1 );
        }

        let taskID = entry.id;
        this._reminderMain.loadEntries( this.app.entries, this );
        this.setActiveWindow( this._reminderMain );
        this._reminderApp._editMailEntry = null;

        await this._reminderApp.saveData();
        await this._reminderApp.deleteTask( taskID );
      } 
    );


    this._reminderMailView.saveButton.onClick( 
      async ( ev ) => 
      { 
        this._reminderMailView.ensureDataIsSaved();

        let entry = deepClone( reminderApp._editMailEntry );
        entry.date

        let index = reminderApp.data.mailEntries.findIndex( me => me.id === entry.id );

        if ( index === -1 )
        {
          reminderApp.data.mailEntries.push( entry );
        }
        else
        {
          reminderApp.data.mailEntries[ index ] = entry;
        }

        console.log( "Saved:", reminderApp.data );

        
        this._reminderApp._editMailEntry = null;
        this._reminderMain.loadEntries( this.app.entries, this );
        this.setActiveWindow( this._reminderMain );

        await this._reminderApp.saveData();
      } 
    );

    this._reminderMain.loadEntries( this.app.entries, this );
  }

  setActiveWindow( window: DomElement<any> )
  {
    this._activeWindow = window;

    this.windows.forEach(
      ( w )=>
      { 
        ClassFlag.visible.setAs( w.element, w === window );
      }
    )

  }
}